@if (components?.length > 0) {
  <section class="mt-8">
    <!-- Header -->
    <div class="mb-2 flex items-center gap-1.5">
      <mat-icon class="text-base">receipt_long</mat-icon>
      <p class="text-[lg uppercase tracking-widest">
        Billing components ({{ components.length }})
      </p>
    </div>

    <!-- List -->
    <div class="overflow-hidden border border-gray-100">
      @for (component of components; track component.Id) {
        <div
          class="flex items-center justify-between border-b border-gray-100 px-4 py-2.5 last:border-b-0 even:bg-gray-50/50"
        >
          <span class="text-sm text-gray-700">{{
            component.Display_Name__c
          }}</span>
          <span
            class="text-sm font-medium"
            [ngClass]="
              component.MRR__c === 0 ? 'text-gray-300' : 'text-gray-800'
            "
          >
            {{ component.MRR__c | currency }}
          </span>
        </div>
      }
    </div>
  </section>
}
